import { useRef } from 'react'
import { motion } from 'framer-motion'
import { useInView } from '../../hooks/useInView'
import { ReactComponent as AppleLogo } from '../../assets/logos/apple.svg'
import { ReactComponent as GooglePlayLogo } from '../../assets/logos/google-play.svg'

export default function PricingCTA() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { threshold: 0.3 })

  return (
    <section ref={ref} className="px-6 pb-24 pt-12 md:pb-32 md:pt-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, ease: [0.38, 0.005, 0.215, 1] as const }}
        className="mx-auto max-w-5xl rounded-3xl bg-oak-butter px-8 py-14 md:px-12 md:py-20"
      >
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:gap-10">
          <div className="flex h-14 shrink-0 items-center justify-center gap-3 rounded-2xl bg-white/60 px-4 md:h-16 md:px-5">
            <AppleLogo className="h-7 w-7 md:h-8 md:w-8" />
            <GooglePlayLogo className="h-7 w-7 md:h-8 md:w-8" />
          </div>
          <p className="text-[clamp(17px,2vw,22px)] font-medium leading-[1.4] tracking-[-0.3px] text-oak-black/80">
            Publish to the app store in minutes, not months. Your brand, your app, your community — live on both platforms.
          </p>
        </div>
      </motion.div>
    </section>
  )
}
